import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const FAMILY_REVIEW_NAMES = ['Mike Seibert', 'Pavani Kanduri', 'Kavya Reddy'];
export function FamilyReviews() {
  const familyReviews = STORM_REVIEWS.filter(r => FAMILY_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-off-white" data-id="element-1139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1140">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1141">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1142">
            Real Families. Real Reviews.
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1143">
            These reviews come directly from Storm parents and students. No
            stock testimonials — just real families from across Southeast
            Michigan.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-1144">
          {familyReviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-1145" />)}
        </div>
      </div>
    </section>;
}